import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "border": "1px solid black",
    "padding": ".2rem"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "max-width": "8vw",
    "max-height": "20vh",
    "overflow": "scroll scroll",
    "height": "100%",
    "padding": ".2rem"
  }
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Check All ");

const _hoisted_4 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "max-width": "8vw",
    "max-height": "20vh",
    "overflow": "scroll scroll",
    "height": "100%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_checkbox = _resolveComponent("el-checkbox");

  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString($props.title), 1), $props.multiple ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_checkbox, {
    indeterminate: $data.isIndeterminate,
    modelValue: $data.checkAll,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.checkAll = $event),
    onChange: $options.handleCheckAllChange
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }, 8, ["indeterminate", "modelValue", "onChange"]), _createVNode(_component_el_checkbox_group, {
    style: {
      "display": "flex",
      "flex-direction": "column",
      "margin-top": ".4rem"
    },
    modelValue: $data.checkedOptions,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.checkedOptions = $event),
    onChange: $options.handlecheckedOptionsChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.optionData, item => {
      return _openBlock(), _createBlock(_component_el_checkbox, {
        label: item.id,
        key: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item[$props.label]), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_radio_group, {
    modelValue: $data.checkedOptions[0],
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.checkedOptions[0] = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.optionData, item => {
      return _openBlock(), _createBlock(_component_el_radio, {
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 256))]),
    _: 1
  }, 8, ["modelValue"])]))]);
}